import styled from '@emotion/styled';

// Bewusst der sui-core-Button statt des Stellenportal-Buttons: der Datei-Bereich hat immer einen
// hellen Hintergrund (surface.raised), die Button-Farbe des Kunden kann darauf unsichtbar sein.
import { Button as _Button } from '@hrworks/sui-core/Button';

const FileManagerWrapper = styled.div(({ theme }) => ({
  backgroundColor: theme.eclipseTier2Color.surface.raised,
  borderRadius: theme.eclipseTier1.radius['12px'],
  padding: theme.eclipseTier1.spacing['12px'],
}));

const Button = styled(_Button)({
  whiteSpace: 'normal',
  maxWidth: '100%',
});

export const S = {
  FileManagerWrapper,
  Button,
} as const;
